import { OnInit, Component } from "@angular/core";
import { Router } from "@angular/router";
import { Listing } from "@app/data/listing";
import { TreeNode } from "primeng/api";
import { HttpClient } from "@angular/common/http";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { BrandEditorComponent } from "../catalog-editor/brand-editor.component";
import { ColorSelectorComponent } from "../catalog-editor/color-selector.component";
import { SVGEditorComponent } from "../catalog-editor/svg-editor.component";
import { AssetsPickerComponent } from "../catalog-editor/assets-picker.component";

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    BrandEditorComponent,
    ColorSelectorComponent,
    SVGEditorComponent,
    AssetsPickerComponent,
  ],
  templateUrl: "./playground.component.html",
  animations: [],
})
export class PlaygroundComponent {
  imageUrl: string =
    "https://rxjs-dev.firebaseapp.com/assets/images/marble-diagrams/retryWhen.png";

  selectedColor: string;
  loading: boolean = true;
  listings: Listing[] = [];
  selectedNodes: TreeNode[] = [];
  selectedAsset: string;
  svg: string;
  cssSVG: string;
  branding: string =
    "@import url('https://fonts.googleapis.com/css?family=Bebas%20Neue%3Aregular');@import url('https://fonts.googleapis.com/css?family=Roboto%3A100%2C100italic%2C300%2C300italic%2Cregular%2Citalic%2C500%2C500italic%2C700%2C700italic%2C900%2C900italic');\nbody {\n\t/* Colors */\n\t--primary-color: #282828;\n\t--secondary-color: rgb(119, 119, 119);\n\t--contrast-color: white;\n\n\t/* Fonts */\n\t--primary-font-family: 'Bebas Neue';\n\t--secondary-font-family: \"Roboto\";\n\n}";
  style: string = "";
  editorOptions = { theme: "vs-dark", language: "css" };
  brandColors = [
    {
      key: "primary-color",
      name: `Primary Color`,
      value: "#234253",
    },
    {
      key: "secondary-color",
      name: `Secondary Color`,
      value: "#2fe253",
    },
    {
      key: "contrast-color",
      name: `Tertiary Color`,
      value: "#2fe2df",
    },
  ];

  constructor(private router: Router, private httpClient: HttpClient) {}

  protected handleSelectionChange(nodes: TreeNode[]) {
    this.selectedNodes = nodes;
  }

  imageUploaded(image: string) {
    console.log(image);
  }
  public throwTestError(): void {
    throw new Error("Sentry Test Error");
  }
}
